export { default as Description } from './Description';
export { default as Field } from './Field';
export { default as InputTimeout } from './InputTimeout';
export { default as ModalEnfocable } from './ModalEnfocable';



// WEBPACK FOOTER //
// ./src/componentes/semantic-ui-extended/index.ts